/* eslint-disable */
import React from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';
import { removeDefaultStyles } from '../../Utils/buttonStyle';

const renderCheckboxes = (...args) => {
  const [mainKey,
  content,
  subMenu,
  subItemKey,
  subKey,
  subItem,
  userDetails,
  roleValue,
  handleCheckBoxSubMenu,
  disableTask
  ] = args;

  return Object.keys(content[subItemKey]?.actions).map((task) => {
    const checked = content[subItemKey].actions[task];
    const permission = userDetails?.find(
      (item) => item.module === content[subItemKey].module,
    );
    const isDisabled = disableTask(content[subItemKey]?.module, task);
    const operation =
      !isDisabled && (checked === false ? false : checked === true || Boolean(permission?.actions?.includes(task)));

    return (
      <FormControlLabel
        key={`${subItemKey}-${task}`}
        control={
          <Checkbox
            name={`${subItemKey}-${task}`}
            checked={operation}
            onChange={(e) =>
              handleCheckBoxSubMenu(
                mainKey,
                content,
                subMenu,
                subItemKey,
                subKey,
                subItem,
                task,
                e
              )
            }
            disabled={!roleValue || isDisabled}
          />
        }
        label={task}
      />
    );
  });
};

const PermissionSubModule = ({
  item,
  subMenu,
  userDetails,
  roleValue,
  handleToggleSubMenu,
  handleCheckBoxSubMenu,
  disableTask,
  checkboxState,
}) => {
  return (
    <>
      {subMenu &&
        Object.keys(subMenu).map((subItem) => {
          const { title, content, isActive } = subMenu[subItem];
          return (
            <div className="sub-menu" key={title}>
              <div className="sub-container">
                <button style={removeDefaultStyles} onClick={() => handleToggleSubMenu(item, subItem)}>
                  <div className="tab">
                    <span className="tab-icon">
                      {isActive ? <FaChevronDown /> : <FaChevronRight />}
                    </span>
                    {title}
                  </div>
                </button>
                
                {isActive &&
                  Object.keys(content).map((subItemKey, subKey) => (
                    <div className="tab sub" key={subKey+1}>
                      <span className="sub-menu-item">{subItemKey}</span>
                      {renderCheckboxes(
                        item,
                        content,
                        subMenu,
                        subItemKey,
                        subKey,
                        subItem,
                        userDetails,
                        roleValue,
                        handleCheckBoxSubMenu,
                        disableTask,
                        checkboxState,
                      )}
                    </div>
                  ))}
              </div>
            </div>
          );
        })}
    </>
  );
};

export default PermissionSubModule;

PermissionSubModule.propTypes = {
  item: PropTypes.any.isRequired,
  subMenu: PropTypes.any.isRequired,
  userDetails: PropTypes.any.isRequired,
  roleValue: PropTypes.any.isRequired,
  handleToggleSubMenu: PropTypes.func.isRequired,
  handleCheckBoxSubMenu: PropTypes.func.isRequired,
  disableTask: PropTypes.any.isRequired,
  checkboxState: PropTypes.any,
};

PermissionSubModule.defaultProps = {
  checkboxState: {},
};